module.exports = {
  metadata: {
    name: 'Stacktape docs',
    short_name: 'Docs',
    description: 'Stacktape - Cloud development for humans',
    language: 'en',
    pathPrefix: '/',
    favicon: 'static/assets/favicon.png',
    themeColor: '#70C8B6', // Used for setting manifest and progress theme colors.
    backgroundColor: '#1B1B1B', // Used for setting manifest background color.
    url: 'https://docs.stacktape.com'
  },
  coreRepoPaths: ['C:\\Projects\\core', '/Users/congy/Desktop/projects/core', '/home/simon/Documents/stacktape/core'],
  jargon: {},
  responsiveBreakpoints: {
    sm: '(max-width: 850px)',
    md: '(min-width: 850px)',
    lg: '(min-width: 1287px)',
    xlg: '(min-width: 1850px)',
    xxlg: '(min-width: 2350px)'
  },
  header: {
    enabled: true,
    logo: 'static/assets/favicon.png',
    logoLink: '/',
    links: [
      {
        text: 'Main page',
        link: 'https://stacktape.com',
        external: true
      },
      {
        text: 'AWS docs',
        link: 'https://docs.aws.amazon.com/',
        external: true
      }
    ]
  },
  sidebar: {
    forcedNavOrder: ['/getting-started', '/cli', '/resources', '/configuration', '/developing'],
    groups: [
      {
        order: 1,
        path: '/getting-started',
        title: 'Getting Started',
        icon: 'GettingStarted'
      },
      {
        order: 2,
        path: '/cli',
        title: 'CLI',
        icon: 'Cli'
      },
      {
        order: 3,
        path: '/sdk',
        title: 'SDK',
        icon: 'Sdk'
      },
      {
        order: 4,
        path: '/resources',
        title: 'Resources',
        icon: 'Resource'
      },
      {
        order: 5,
        path: '/configuration',
        title: 'Configuration',
        icon: 'Config'
      },
      {
        order: 6,
        path: '/user-guides',
        title: 'User Guides',
        icon: 'Guide'
      }
    ]
  },
  social: {
    github: 'https://github.com/stacktape/stacktape',
    linkedin: 'https://www.linkedin.com/company/stacktape',
    twitter: 'https://twitter.com/stacktape',
    facebook: 'https://facebook.com/stacktape',
    slack: 'https://stacktape-community.slack.com/'
  },
  features: {
    previousNext: {
      enabled: true,
      arrowKeyNavigation: true
    },
    search: {
      algoliaAppId: 'HBUYV37I88', // algolia application id
      algoliaApiKey: '056b76a9ae0fa9039235c74a55e14556',
      algoliaAdminKey: '10b499233a8296a2fab811656552a5fc', // algolia admin key to index
      indexName: 'docs',
      enabled: true,
      engine: 'algolia',
      placeholder: 'Search',
      startComponent: 'input',
      excerptSize: 8000,
      debounceTime: 250,
      snippetLength: 23,
      hitsPerPage: 10,
      showStats: true,
      pagination: {
        enabled: true,
        totalPages: 6,
        showPrevious: true,
        showNext: true
      }
    },
    showMetadata: true,
    toc: {
      show: true,
      depth: 2
    }
  },
  projectPaths: {
    currentConfigSchema: '@generated/current-config-schema.json',
    currentCliSchema: '@generated/current-cli-schema.json',
    currentSdkSchema: '@generated/current-sdk-schema.json',
    starterProjects: '@generated/starter-projects.json'
  },
  links: {
    configSchemaUrl: 'https://stacktape-schema.web.app/config-schema.json',
    cliSchemaUrl: 'https://stacktape-schema.web.app/cli-schema.json',
    sdkSchemaUrl: 'https://stacktape-schema.web.app/sdk-schema.json'
  }
};
